import DA from './DA.svg';
import DFMEA from './DFMEA.svg';
import FindSolutions from './FindSolutions.svg';
import Formulation from './Formulation.svg';
import IdeaValidation from './IdeaValidation.svg';
import InventionDisclosure from './InventionDisclosure.svg';
import QuickResearch from './QuickResearch.svg';
import SearchLeft from './SearchLeft.svg';
import Roadmap from './roadmap.svg';
import DocumentAnalyzer from './DocumentAnalyzer.svg';
import SubstanceInquiry from '@/assets/icon/playbooks/substance_search.svg';
import StructureSearch from '@/assets/icon/playbooks/structure_search.svg';
import WorkflowSearch from '@/assets/icon/playbooks/workflow_search.svg';
import MetalSearch from '@/assets/icon/playbooks/metal_search.svg';
import PropertySearch from '@/assets/icon/playbooks/property_search.svg';

export default {
  DA,
  DFMEA,
  FindSolutions,
  Formulation,
  IdeaValidation,
  InventionDisclosure,
  QuickResearch,
  SearchLeft,
  Roadmap,
  DocumentAnalyzer,
  SubstanceInquiry,
  StructureSearch,
  WorkflowSearch,
  MetalSearch,
  PropertySearch,
};
